import React from "react"
import rehypeReact from "rehype-react"
import styled from "styled-components"

/* Wrap the original table around a div to make it horizontally scrollable */
const Table = props => {
  const renderTableFromAst = new rehypeReact({
    Fragment: React.Fragment,
    createElement: React.createElement,
  }).Compiler

  return <Wrapper>{renderTableFromAst(props.node)}</Wrapper>
}

const Wrapper = styled.div`
  margin: 1.7em 0;
  border-radius: 8px;
  overflow-x: auto;
  border: 1px solid #ebeaeb;

  table {
    margin: 0;
  }
`

export default Table
